<div class="form-typography margin-bottom-large reference-list">
  <h1 class="text-center text-left-small-only margin-bottom-small padding-horizontal-medium" *ngIf="subjectSource && subjectSource.length > 0; else noSubjectSource">{{ subject }}</h1>
  <ng-template #noSubjectSource>
    <p *ngIf="isSubjectSourceSet" class="flex flex-justify-center flex-content-center padding-top-large">You do not have any policies for which you can apply the selected Support options</p>
    <p *ngIf="isSubjectSourceSet" class="flex flex-justify-center flex-content-center padding-bottom-large">Go back and to select other Support options</p>
    <div *ngIf="!isSubjectSourceSet" class="padding-xxbig flex flex-justify-center">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </ng-template>

  <mat-radio-group aria-label="Select an option" (change)="selectedItem($event)">
    <ng-container *ngFor="let item of subjectSource">
      <div class="radio-wrapper">
        <mat-radio-button [value]="item" class="large" [checked]="item.checked">
          <open-svg-icon name="{{ item.icon }}" class="xmedium"></open-svg-icon>
          <div class="margin-bottom-xsmall" *ngIf="item.policyNumber">
            <open-badge [label]="item.status" [variant]="badgeStatus[item.status] || 'default'"></open-badge>
          </div>
          <div class="tile-label-content">
            <h4 class="margin-bottom-medium">{{ item.label }}</h4>
            <p class="margin-bottom-xxsmall"><strong>{{ item.policyNumber || item.claimNumber }}</strong></p>
            <p><strong>{{ item.coveredEntity }}</strong></p>
          </div>
        </mat-radio-button>
      </div>
    </ng-container>
  </mat-radio-group>
</div>

<div class="text-center" *ngIf="helpReferenceAnswer">
  <button class="margin-bottom-large help-flow-action" mat-flat-button color="primary" (click)="goToNextStep()">Continue</button>
</div>
